import { SvgIcon } from '@mui/material';

const Icon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <title>Layout</title>
    <rect
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x="3"
      y="3"
      width="18"
      height="18"
      rx="2"
      ry="2"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="3"
      y1="9"
      x2="21"
      y2="9"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="9"
      y1="21"
      x2="9"
      y2="9"
    />
  </SvgIcon>
);

export default Icon;
